export interface GetReserveGroupRequest {
  id: number
}

export function GetReserveGroupRequestToJSON(
  value: GetReserveGroupRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined
  }
}
